import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import S from "../../../styles/pages/HistoryTach/TachHistoryTable";
import { ReactComponent as Document } from "../../../assets/icons/Document.svg";
import { ReactComponent as Print } from "../../../assets/icons/Print.svg";
import ModalViewTach from "../../Workflows/DocumentTach/ModalViewTach";
import { useTachHistory } from "../../../context/TachContext/TachHistoryContext";
import ConfirmPrintModal from "../ConfirmPrintModal";
import { getSignedUrlDocument } from "../../../service/Docente/HistoryTachService";
import GenericUtils from "../../../utils/GenericUtils";

const TachHistoryTable: React.FC = () => {
    const { instance } = useMsal();
    const { documents } = useTachHistory();
    const [viewTachModal, setViewTachModal] = useState<boolean>(false);
    const [openPrintModal, setOpenPrintModal] = useState<boolean>(false);
    const [documentId, setDocumentId] = useState<string>("");
    const [signedUrl, setSignedUrl] = useState<string>("");

    const showPrintModal = (docId: any) => {
        setOpenPrintModal(true);
        setDocumentId(docId);
    };

    const showTachDoc = async (docId: any) => {
        const response = await getSignedUrlDocument(instance, docId, false);

        if (GenericUtils.isSuccessStatus(response)) {
            setSignedUrl(response.data.signedUrl);
        }
        setViewTachModal(true);
    };

    const nameConfiguration = (fileName: string, vigencia: string): string => {
        if (!fileName) {
            const initialPeriod = vigencia.split(" - ")[0];
            const initialPeriodYear = initialPeriod.split("/")[2];
            const initialPeriodMonth = initialPeriod.split("/")[1];
            const isSecondSemester = initialPeriodMonth >= "07" ? "2" : "1";

            return `TACH ${isSecondSemester}° Semestre ${initialPeriodYear}`;
        }

        const file = fileName.split(".")[0];
        const parts = file.split("_");
        const year = parts[3];
        const period = parts[4];
        return `TACH ${period}° Semestre ${year}`;
    };

    // const orderingDates = (dateString: string): Date => {
    //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //     const [start, end] = dateString.split(" - ");
    //     const [startDay, startMonth, startYear] = start.split("/").map(Number);
    //     return new Date(startYear, startMonth - 1, startDay);
    // };

    // const documentosOrdenados = documents.sort((a, b) => {
    //     const dateEndA = orderingDates(a.vigencia.split(" - ")[1]);
    //     const dateEndB = orderingDates(b.vigencia.split(" - ")[1]);

    //     if (dateEndA.getTime() !== dateEndB.getTime()) {
    //         return dateEndB.getTime() - dateEndA.getTime();
    //     }

    //     const dateStartA = orderingDates(a.vigencia);
    //     const dateStartB = orderingDates(b.vigencia);
    //     return dateStartB.getTime() - dateStartA.getTime();
    // });

    return (
        <S.TachHistoryTableContainer>
            <S.TachHistoryTable>
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>ID</th>
                        <th>Vigência</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {documents.length > 0 ? (
                        documents.map((document) => (
                            <tr key={document.id}>
                                <td>
                                    {nameConfiguration(
                                        document.nome,
                                        document.vigencia
                                    )}
                                </td>
                                <td>{document.id}</td>
                                <td>{document.vigencia}</td>
                                <td>
                                    <S.TachIconButton
                                        type="button"
                                        onClick={() =>
                                            showPrintModal(document.id)
                                        }
                                    >
                                        <Print width={20} height={19} />
                                    </S.TachIconButton>
                                    <S.TachIconButton
                                        type="button"
                                        onClick={() => showTachDoc(document.id)}
                                    >
                                        <Document width={20} height={19} />
                                    </S.TachIconButton>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={4}>
                                Não há documentos TACH para o docente.
                            </td>
                        </tr>
                    )}
                </tbody>
            </S.TachHistoryTable>
            {viewTachModal && (
                <ModalViewTach
                    open={viewTachModal}
                    onClose={() => setViewTachModal(false)}
                    url={signedUrl}
                />
            )}
            {openPrintModal && (
                <ConfirmPrintModal
                    open={openPrintModal}
                    onClose={() => setOpenPrintModal(false)}
                    docId={documentId}
                />
            )}
        </S.TachHistoryTableContainer>
    );
};

export { TachHistoryTable };
